import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SewerTinderGuard = createFeatureGuard(Feature.SewerTinder);